<template>
  <div class="relative z-30 p-2 pb-0 flex justify-end">
    <div :class="!ready && 'ske'">
      <select v-model="packageId" id="location" name="location" class="mt-1 w-44 text-sm block pl-2 pr-10 py-1 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md">
        <option value="null">All packages</option>
        <option
          v-for="pack in availablePackages"
          :key="pack.uid"
          :value="pack.module_id"
        >{{ pack.name }}</option>
      </select>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex"

export default {
  props: ['value'],
  data() {
    return {
      packageId: null,
    }
  },
  computed: {
    ...mapGetters({
      availablePackages: 'editor/availablePackages',
      ready: 'editor/ready',
    }),
  },
  watch: {
    packageId() {
      this.$emit('input', this.packageId)
    },
  },
}

</script>
